import PropTypes from 'prop-types';

import { BookingContext, bookingClassNameModifier, bookingView } from '../booking.context';
import styles from './BookingPartner.scss';

export const EmptyBookingPartner = ({ partnerTitle, extraPartnerTitle = null }) => (
  <BookingContext.Consumer>
    {(context) => (
      <div
        className={styles[`${bookingClassNameModifier(context)}BookingReview__partner`]}
        data-testid="appointmentPartner"
      >
        {context === bookingView.appointment ? (
          <div
            className={styles[`${bookingClassNameModifier(context)}BookingReview__partner_empty`]}
          >
            <div
              className={
                styles[`${bookingClassNameModifier(context)}BookingReview__partner_empty_noAdvisor`]
              }
            >
              <strong>{partnerTitle}</strong>
            </div>
          </div>
        ) : null}
        <div>
          <p data-testid="partner_position">{`One of our ${(extraPartnerTitle || partnerTitle).toLowerCase()}s will take you through your appointment.`}</p>
        </div>
      </div>
    )}
  </BookingContext.Consumer>
);

EmptyBookingPartner.propTypes = {
  partnerTitle: PropTypes.string.isRequired,
  extraPartnerTitle: PropTypes.string,
};
